import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import AccountFunctions from '../services/AccountService';
import InstrumentFunctions from '../services/InstrumentService'
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa';
import { MdClear } from 'react-icons/md';
import '../layout/site.css';
import '../layout/print.css'
import CalsCertsFunctions from '../services/CalsCertsService';
import Moment from 'react-moment';
import Select from 'react-dropdown-select';
import Modal from 'react-bootstrap/Modal';

export class ExistingPackingList extends Component {
    static displayName = ExistingPackingList.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            fromDate: null,
            toDate: null,
            instrumentsOrig: [],
            instruments: [],
            instrumentsAdd: [],
            assets: [],
            printItems: [],
            Account: { notes: [] },
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            showToast: false,
            showPackingList: false,
            poNo: '',
            useCC: 'No',
            instructions: '',
            showRequestQuote: false,
            manufacturer: '',
            model: '',
            serialNo: '',
            range: '',
            description: '',
            qty: ''
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.handleCreatePackingList = this.handleCreatePackingList.bind(this);
        this.handlePackingListCreate = this.handlePackingListCreate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handleRequestQuote = this.handleRequestQuote.bind(this);
        this.handleAddNew = this.handleAddNew.bind(this);
        this.handleDeleteAdditional = this.handleDeleteAdditional.bind(this);
        this.handleQuoteRequestSubmission = this.handleQuoteRequestSubmission.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }


    handleDeleteAdditional(index) {
        var instruments = this.state.instrumentsAdd;
        if (index > -1 && index < instruments.length) {
            instruments.splice(index, 1);
            this.setState({ instrumentsAdd: instruments });
        }
    }

    handleAddNew() {
        var manufacturer = this.state.manufacturer;
        var description = this.state.description;
        var model = this.state.model;
        var size = this.state.range;
        var serialno = this.state.serialNo;
        var pieces = this.state.qty;

        if (manufacturer === "")
            manufacturer = "N/A";
        if (description === "")
            description = "N/A";
        if (model === "")
            model = "N/A";
        if (size === "")
            size = "N/A";
        if (serialno === "")
            serialno = "N/A";
        if (pieces === "")
            pieces = "N/A"

        if (manufacturer != "" && description != "" && model != "" && size != "" && serialno != "" && pieces != "") {
            var instruments = this.state.instrumentsAdd;
            instruments.push({ manufacturer: manufacturer, model: model, serialNo: serialno, description: description, range: size, qty: pieces });
            this.setState({ instrumentsAdd: instruments, manufacturer: '', description: '', model: '', range: '', serialNo: '', qty: '' });
        }
    }

    handleClose() {
        this.setState({ showToast: false, showPackingList: false, showRequestQuote: false });
    }

    handleRequestQuote() {
        this.setState({ manufacture: '', model: '', serialNo: '', description: '', range: '', qty: '', assets: [], showRequestQuote: true });
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.instruments.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.instruments.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.instruments.length / pageSize) })
        }
    }

    handlePackingListCreate() {
        var items = this.state.instruments.filter(function (instrument) {
            return instrument.selected != null && instrument.selected == true; 
        }).sort(function (a, b) {
                return (a.partNo.localeCompare(b.partNo));
        });
        this.setState({ printItems: items });
        this.setState({ poNo: '', useCC: 'No', instructions: '', showPackingList: true});
    }

    handleCreatePackingList() {
        this.setState({showPackingList: false});
        this.handlePackingListSubmission();

        setTimeout(() => {
            window.print();
        }, 500);
    }

    async handleQuoteRequestSubmission() {
        this.setState({ showRequestQuote: false });

        var filtered = this.state.instruments.filter(function (instrument) {
            return instrument.selected == true;
        });

        var data = { poNo: '', useCC: false, instructions: '', data: filtered, additional: this.state.instrumentsAdd };

        var response = await InstrumentFunctions.postExistingQuoteRequestAsync(data);

        if (response != null) {
            this.setState({ showToast: true });
        }
    };

    async handlePackingListSubmission() {
        //var filtered = this.state.instruments.filter(function (instrument) {
        //    return instrument.selected == true;
        //});

        //var data = { poNo: this.state.poNo, useCC: this.state.useCC == 'Yes', instructions: this.state.instructions, data: filtered }

        //var response = await InstrumentFunctions.postExistingPackingListAsync(data);
    };

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        //this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {
        }
        else {
        }
        this.getCalibrations();
        this.getAccountData();
    }

    async getAccountData() {
        var account = await AccountFunctions.getAccountAsync();

        if (account.success == true) {
            if (account.data != null) {
                var data = account.data;
                if (data.customerAddress1 === data.shipToAddress1 && data.customerAddress2 == data.shipToAddress2 && data.customerCity === data.shipToCity && data.customerState === data.shipToState && data.customerZip === data.shipToZip) {
                    this.setState({ shippingSame: true });
                    data.shippingSame = true;
                } else {
                    this.setState({ shippingSame: false });
                    data.shippingSame = false;
                }
                var original = JSON.stringify(data);
                this.setState({ Account: data, OriginalAccount: original });
            }
        }
    }

    async getCalibrations() {
        var calibrations = await CalsCertsFunctions.getCalibrationsAsync();

        if (calibrations.success == true) {
            if (calibrations.data != null) {
                this.setState({ instruments: calibrations.data.slice(), instrumentsOrig: calibrations.data.slice() });
            }
        }

    }

    //setWindowDimensions = () => {
    //    this.setState({
    //        height: window.innerHeight,
    //        width: window.innerWidth
    //    });
    //};

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchInstruments();
        }
    }

    handleCheckAll(event) {
        var instruments = this.state.instruments;
        var checked = event.target.checked;

        instruments.forEach((instrument, index) => {
            instrument.selected = checked;
        });

        this.setState({ instruments: instruments });
    }

    handleSelectClick(event, partNo) {
        this.handleCheck(event.target.checked, partNo);
    }

    handleCheck(checked, partNo) {
        var instruments = this.state.instruments;
        var filtered = instruments.filter(function (instrument) {
            return instrument.partNo == partNo;
        });

        if (filtered.length > 0) {
            filtered[0].selected = checked;
        }

        this.setState({ instruments: instruments });
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.instruments.slice(indexOfFirstItem, indexOfLastItem);

        const selectedItems = this.state.instruments.filter(function (instrument) {
            return instrument.selected != null && instrument.selected == true; 
        }).map((instrument) => 
            ({label: instrument.partNo + ' - ' + instrument.description, value: instrument.partNo})
        ).sort(function (a, b) {
                return (a.value.localeCompare(b.value));
        });

        const customContentRenderer = () => {
            return (
                <div>{selectedItems.length} Instruments Selected</div>
            );
        }

        const customNoDataRenderer = () => {
            return (
                <div>0 Instruments Selected</div>
            );
        }

        const additionalItems = this.state.instrumentsAdd;

        const renderAdditionalItems = additionalItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td><a href="javascript:void(0)" onClick={() => this.handleDeleteAdditional(i)}>Delete</a></td>
                    <td>{instrument.manufacturer}</td>
                    <td>{instrument.model}</td>
                    <td>{instrument.serialNo}</td>
                    <td>{instrument.description}</td>
                    <td>{instrument.range}</td>
                    <td>{instrument.qty}</td>
                </tr>
            )
        });

        const customItemRenderer = ({ item, itemIndex, props, state, methods }) => (
            <div style={{width: '100%'}}>
                <div style={{padding: '5px', float: 'left'}}>
                    {item.label}
                </div>
                <div style={{padding: '5px', float: 'right'}}>
                    <MdClear
                        onClick={() => this.handleCheck(false, item.value)}
                        color={'#0a58ca'}
                    />
                </div>
            </div>
        );

        const renderItems = currentItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td>
                    <Input
                            type='checkbox'
                            onChange={ (e) => this.handleSelectClick(e, instrument.partNo) }
                            checked={instrument.selected}
                            style={{ marginLeft: '0.0rem' }}
                            className='centerCheckBoxInput'
                        />
                    </td>
                    <td>{instrument.partNo}</td>
                    <td>{instrument.mte}</td>
                    <td>{instrument.description}</td>
                    <td>{instrument.serialNo}</td>
                    <td>{instrument.department}</td>
                    <td>{instrument.calDate != null && <Moment format="M/D/YY">{instrument.calDate}</Moment>}</td>
                    <td>{instrument.expDate != null && <Moment format="M/D/YY">{instrument.expDate}</Moment>}</td>
                </tr>
            )
        });

        const renderPrintItems = this.state.printItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td>{instrument.partNo}</td>
                    <td>{instrument.mte}</td>
                    <td>{instrument.description}</td>
                    <td>{instrument.serialNo}</td>
                    <td>{instrument.department}</td>
                    <td>{instrument.calDate != null && <Moment format="M/D/YY">{instrument.calDate}</Moment>}</td>
                    <td>{instrument.expDate != null && <Moment format="M/D/YY">{instrument.expDate}</Moment>}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.instruments.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <>
                <div className='content-area'>
                    <Container>
                        <Row>
                            <Col>
                                <h2 style={{ color: '#233c7c' }}>Existing Instruments</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <div className='col' style={{ maxWidth: '200px' }}></div>
                                    <div className='col' style={{ maxWidth: '200px', lineHeight: '48px' }}>Due Date From</div>
                                    <div className='col' style={{ maxWidth: '200px', lineHeight: '48px' }}>Due Date To</div>
                                    <div className='col'></div>
                                    <div className='col marginTop' style={{ textAlign: 'right' }}>
                                        <Button
                                            color='primary'
                                            className='standardButton'
                                            onClick={(e) => { this.handleRequestQuote() }}
                                            disabled={this.state.loading ? true : false}
                                        >
                                            Request Quote
                                        </Button>
                                    </div>
                                </Row>
                                <Row>
                                    <div className='col' style={{ maxWidth: '200px' }}>
                                        <Input
                                            type='text'
                                            onChange={(e) => this.setState({ search: e.target.value })}
                                            className='fullInput'
                                            onKeyPress={this.handleKeyPress}
                                            placeholder='R#, M&TE, Serial#'
                                        />
                                    </div>
                                    <div className='col' style={{ maxWidth: '200px' }}>
                                        {/*//TODO: Replace with a datepicker.  Maybe react-datepicker? */}
                                        <Input
                                            type='date'
                                            onChange={(e) => this.setState({ fromDate: e.target.value })}
                                            name='DueDateFrom'
                                            id='DueDateFrom'
                                            className='fullInput'
                                            onKeyPress={this.handleKeyPress}
                                            placeholder='From Date'
                                        />
                                    </div>
                                    <div className='col' style={{ maxWidth: '200px' }}>
                                        {/*//TODO: Replace with a datepicker.  Maybe react-datepicker? */}
                                        <Input
                                            type='date'
                                            onChange={(e) => this.setState({ toDate: e.target.value })}
                                            name='DueDateTo'
                                            id='DueDateTo'
                                            className='fullInput'
                                            onKeyPress={this.handleKeyPress}
                                            placeholder='To Date'
                                        />
                                    </div>
                                    <div className='col marginTop' style={{ maxWidth: '125px' }}>
                                        <Button
                                            color='primary'
                                            className='standardButton'
                                            style={{ width: '125px' }}
                                            onClick={() => this.searchInstruments()}
                                            disabled={this.state.loading ? true : false}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                    <div className='col marginTop' style={{ textAlign: 'right' }}>
                                        <Button
                                            color='primary'
                                            className='standardButton'
                                            onClick={() => this.handlePackingListCreate()}
                                            disabled={this.state.loading ? true : false}
                                        >
                                            Create Packing List
                                        </Button>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        {this.state.instruments.length !== 0 && (
                        <Row className='row-20'>
                            <div className='col'>
                                <Select
                                    className='form-control'
                                    style={{width:'500px', marginRight: '20px', borderRadius: '0.25rem'}}
                                    placeholder=""
                                    noDataRenderer={customNoDataRenderer}
                                    contentRenderer={customContentRenderer}
                                    itemRenderer={customItemRenderer}
                                    onChange={() => undefined}
                                    values={selectedItems}
                                    loading={this.state.loading}
                                    options={selectedItems}
                                    />                        
                            </div>
                            <div className='col' style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </Row>
                        
                        )}
                        <Row style={{ marginTop: '20px' }}>
                            <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div>
                                                    <Input
                                                        type='checkbox'
                                                        onChange={(e) => this.handleCheckAll(e)}
                                                        style={{ marginLeft: '0.0rem' }}
                                                        className='centerCheckBoxInput'
                                                    />
                                                </div>
                                            </th>
                                            <th>
                                                R#
                                                <FaSort
                                                    color={this.state.sort.column === 'partNo' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('partNo')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                M&amp;TE#
                                                <FaSort
                                                    color={this.state.sort.column === 'mte' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('mte')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Tool Description
                                                <FaSort
                                                    color={this.state.sort.column === 'description' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('description')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Serial #
                                                <FaSort
                                                    color={this.state.sort.column === 'serialNo' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('serialNo')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Department
                                                <FaSort
                                                    color={this.state.sort.column === 'department' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('department')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Cal. Date
                                                <FaSort
                                                    color={this.state.sort.column === 'calDate' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('calDate')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Due Date
                                                <FaSort
                                                    color={this.state.sort.column === 'expDate' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('expDate')}
                                                    className='sort-button'
                                                />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading === true && this.state.loadingDocument === false ? (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>

                                        ) : (
                                            <>
                                                {!this.state.noResults ? (
                                                    <>
                                                        {renderItems}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                            <h5>No Results Found</h5>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        {this.state.instruments.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>

                            </div>
                        )}
                    </Container>
                    <Modal show={this.state.showToast} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>Email Sent!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Thank you for requesting a quote for calibration.  A <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team member is working on your quote.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showPackingList} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>Create Packing List</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Col>
                                <Row>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ poNo: e.target.value })}
                                        name='PONo'
                                        id='poNo'
                                        className='fullInput'
                                        value={this.state.poNo}
                                        placeholder='PO #'
                                    />
                                </Row>
                                <Row className='row-10'>
                                    <label>
                                        <Input
                                            type='checkbox'
                                            onChange={(e) => this.setState({ useCC: e.target.checked ? 'Yes' : 'No' })}
                                            name='useCC'
                                            id='useCC'
                                            className='fullInput'
                                            value={this.state.useCC == 'Yes'}
                                            placeholder='Use CC'
                                        />
                                        Pay with credit card?
                                    </label>
                                </Row>
                                <Row className='row-10'>
                                    <textarea
                                        onChange={(e) => this.setState({ instructions: e.target.value })}
                                        name='instructions'
                                        id='instructions'
                                        maxLength={500}
                                        className='form-control marginTop fullInput'
                                        value={this.state.instructions}
                                        placeholder='Special Instructions'
                                    />
                                </Row>
                            </Col>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" className="standardButton btn btn-primary" onClick={this.handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" className="standardButton btn btn-primary" onClick={this.handleCreatePackingList}>
                                Print Packing List
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showRequestQuote} onHide={this.handleClose} dialogClassName="modelWidth">
                        <Modal.Header >
                            <Modal.Title>Request Quote</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Col>
                                <Row>
                                    <Col><h3>Include New Instruments?</h3></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Input
                                            tabIndex='10'
                                            type='text'
                                            name='Manufacturer'
                                            id='Manufacturer'
                                            className='fullInput'
                                            value={this.state.manufacturer}
                                            onChange={(e) => {
                                                this.setState({ manufacturer: e.target.value });
                                            }}
                                            placeholder='Manufacturer'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='11'
                                            type='text'
                                            name='ToolDescription'
                                            id='ToolDescription'
                                            className='fullInput'
                                            value={this.state.description}
                                            onChange={(e) => {
                                                this.setState({ description: e.target.value });
                                            }}
                                            placeholder='Tool Description'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='12'
                                            type='text'
                                            name='ModelNum'
                                            id='ModelNum'
                                            className='fullInput'
                                            value={this.state.model}
                                            onChange={(e) => {
                                                this.setState({ model: e.target.value });
                                            }}
                                            placeholder='Model #'
                                        />
                                    </Col>
                                    <Col style={{ maxWidth: '145px'}}></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Input
                                            tabIndex='13'
                                            type='text'
                                            name='SizeRange'
                                            id='SizeRange'
                                            className='fullInput'
                                            value={this.state.range}
                                            onChange={(e) => {
                                                this.setState({ range: e.target.value });
                                            }}
                                            placeholder='Size / Range'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='14'
                                            type='text'
                                            name='SerialNum'
                                            id='SerialNum'
                                            className='fullInput'
                                            value={this.state.serialNo}
                                            onChange={(e) => {
                                                this.setState({ serialNo: e.target.value });
                                            }}
                                            placeholder='Serial #'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='15'
                                            type='text'
                                            name='NumPieces'
                                            id='NumPieces'
                                            className='fullInput'
                                            value={this.state.qty}
                                            onChange={(e) => {
                                                this.setState({ qty: e.target.value });
                                            }}
                                            placeholder='# of Pieces (if applicable)'
                                        />
                                    </Col>
                                    <Col className="marginTop" style={{ maxWidth: '145px' }}>
                                        <Button
                                            color='primary'
                                            className='standardButton'
                                            style={{ width: '125px' }}
                                            onClick={() => this.handleAddNew()}
                                        >
                                            Add
                                        </Button>
                                    </Col>
                                </Row>
                                <Row className='row-20'>
                                    <Col>
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Delete
                                                    </th>
                                                    <th>
                                                        Manufacturer
                                                    </th>
                                                    <th>
                                                        Model #
                                                    </th>
                                                    <th>
                                                        Serial #
                                                    </th>
                                                    <th>
                                                        Tool Description
                                                    </th>
                                                    <th>
                                                        Size / Range
                                                    </th>
                                                    <th>
                                                        # of Pieces
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!this.state.noResults ? (
                                                    <>
                                                        {renderAdditionalItems}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Col>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                tabIndex='17'
                                variant="secondary" className="standardButton btn btn-primary" onClick={this.handleClose}>
                                Close
                            </Button>
                            <Button
                                tabIndex='18'
                                variant="primary" className="standardButton btn btn-primary" onClick={(e) => this.handleQuoteRequestSubmission()}>
                                Request Quote
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className='print-area'>
                    <Container>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'> 
                                    <tbody>
                                        <tr>
                                            <td colSpan={'2'} style={{ textAlign: 'center' }}>
                                                <img src="/images/ticlogo.jpg" style={{ height: '80px', margin: '12px' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'2'} style={{textAlign: 'center'}}>
                                                <h3>Packing List</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>PO #:</b>&nbsp;{this.state.poNo}</td>
                                            <td><b>Credit Card:</b>&nbsp;{this.state.useCC}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'2'} style={{ whiteSpace: 'unset' }}><b>Special Instructions:</b>&nbsp;{this.state.instructions}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'> 
                                    <thead>
                                        <th>
                                            <h3>Company Information</h3>
                                        </th>
                                        <th>
                                            <h3>Quality Contact</h3>
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Table responsive>
                                                    <tbody>
                                                        <tr>
                                                            <td><b>TIC #:</b></td>
                                                            <td>{this.state.Account.ticNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Company Name:</b></td>
                                                            <td>{this.state.Account.customerName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Address:</b></td>
                                                            <td>{this.state.Account.customerAddress1}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Address 2:</b></td>
                                                            <td>{this.state.Account.customerAddress2}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>City, State, Zip:</b></td>
                                                            <td>{this.state.Account.customerCity}, {this.state.Account.customerState} {this.state.Account.customerZip}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                            <td>
                                                <Table responsive>
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Name:</b></td>
                                                            <td>{this.state.Account.qcName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Office Phone:</b></td>
                                                            <td>{this.state.Account.qcPhone} ext. {this.state.Account.qcExt}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Email:</b></td>
                                                            <td>{this.state.Account.qcEmail}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        <Row className='row-20'>
                            <Col>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                R#
                                            </th>
                                            <th>
                                                M&amp;TE#
                                            </th>
                                            <th>
                                                Tool Description
                                            </th>
                                            <th>
                                                Serial #
                                            </th>
                                            <th>
                                                Dept.
                                            </th>
                                            <th>
                                                Cal. Date
                                            </th>
                                            <th>
                                                Due Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <>
                                            {renderPrintItems}
                                        </>
                                    </tbody>
                                </Table>                            
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }

    // instruments

    async searchInstruments() {
        var search = this.state.search;
        var fromDate = this.state.fromDate;
        var toDate = this.state.toDate;
        var instruments = this.state.instrumentsOrig;

        if (search == null || search == "") {
            if (fromDate !== null && fromDate !== '') {
                var from = new Date(fromDate);
                instruments = instruments.filter(function (instrument) {
                    var expDate = new Date(instrument.expDate);
                    return (expDate.getTime() >= from.getTime());
                });
            }
            if (toDate !== null && toDate !== '') {
                var to = new Date(toDate);
                var endOfDay = 24 * 60 * 60 * 1000;
                instruments = instruments.filter(function (instrument) {
                    var expDate = new Date(instrument.expDate);
                    return (expDate.getTime() <= to.getTime() + endOfDay);
                });
            }
            this.setState({ instruments: instruments });
        } else {
            var instruments = instruments.filter(function (instrument) {
                return instrument.partNo.includes(search) || instrument.mte.includes(search) || instrument.serialNo.includes(search);
            });

            if (fromDate !== null && fromDate !== '') {
                var from = new Date(fromDate);
                instruments = instruments.filter(function (instrument) {
                    var expDate = new Date(instrument.expDate);
                    return (expDate.getTime() >= from.getTime());
                });
            }
            if (toDate !== null && toDate !== '') {
                var to = new Date(toDate);
                var endOfDay = 24 * 60 * 60 * 1000;
                instruments = instruments.filter(function (instrument) {
                    var expDate = new Date(instrument.expDate);
                    return (expDate.getTime() <= to.getTime() + endOfDay);
                });
            }
            this.setState({ instruments: instruments });
        }
    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.instruments;

        if (column === 'expDate' || column === 'calDate') {
            data.sort((a, b) => {
                var dateA = new Date(a[column]);
                var dateB = new Date(b[column]);

                return dateB - dateA;
            });
        } else {
            data.sort((a, b) => a[column] instanceof Date ? (b[column] - a[column]) : a[column].localeCompare(b[column]));
        }

        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            instruments: data,
            sort: {
                column,
                direction
            }
        })
    }
}